import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const BreakawayPoleFlatOriginal = () => {
  console.log('🎯 BreakawayPoleFlatOriginal component loading');
  
  const product = findProductById("breakaway-pole-flat-original");
  
  if (!product) {
    console.error('Product not found:', "breakaway-pole-flat-original");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="breakaway-pole-flat-original"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default BreakawayPoleFlatOriginal; 